import { Link } from "react-router-dom";
import { Wind, Sparkles, Shield, Layers, Flame, Bug } from "lucide-react";
import useSeo from "@/hooks/useSeo";

const ALL_SERVICES = [
  { icon: Wind, title: "Residential Air Duct Cleaning",
    body: "Complete supply, return, and trunk line cleaning under negative pressure with rotary brush agitation. Photo before/after report included." },
  { icon: Layers, title: "Commercial Duct Cleaning",
    body: "Tailored programs for offices, clinics, schools, and retail spaces. NADCA-aligned ACR cleaning standards, off-hours scheduling, certificate of cleaning." },
  { icon: Flame, title: "Dryer Vent Cleaning",
    body: "Full vent-path cleaning from drum to roof cap. Drastically reduces dryer fire risk and cuts dry times in half on most homes." },
  { icon: Sparkles, title: "Antimicrobial Sanitization",
    body: "EPA-registered fogging treatment neutralizes mold, bacteria, viruses, and stubborn odors throughout the air handling system." },
  { icon: Shield, title: "Evaporator Coil Cleaning",
    body: "Restore HVAC efficiency by cleaning the coil — typically improves airflow by 15-30% and lowers energy bills." },
  { icon: Bug, title: "Mold Inspection & Treatment",
    body: "Inspection of plenum, coil pan, and trunks. Treatment plan with antimicrobial application and remediation referrals if needed." },
];

export default function Services() {
  useSeo({
    title: "Services | Full Indoor Air Services",
    description: "Residential & commercial air duct cleaning, dryer vent cleaning, sanitization, coil cleaning and mold treatment across MD, DC, and VA.",
    canonical: "https://capitalindoorair.com/services",
  });

  return (
    <div className="bg-bone" data-testid="services-page">
      <section className="section-pad">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-3xl">
            <div className="eyebrow mb-3">Services</div>
            <h1 className="font-heading text-5xl md:text-6xl tracking-tighter font-light">
              Everything that touches<br /><span className="text-forest">your indoor air.</span>
            </h1>
            <p className="mt-6 text-lg text-muted2 leading-relaxed">
              From annual maintenance cleans to deep mold remediation — we offer the full stack of
              indoor air services so you never have to coordinate multiple vendors.
            </p>
          </div>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-6">
            {ALL_SERVICES.map((s, idx) => {
              const Icon = s.icon;
              return (
                <div key={s.title} className="card-surface p-8 hover-lift" data-testid={`service-${idx}`}>
                  <span className="inline-flex w-12 h-12 rounded-full bg-forest/8 text-forest items-center justify-center mb-5">
                    <Icon size={22} strokeWidth={1.5} />
                  </span>
                  <h3 className="font-heading text-2xl tracking-tight">{s.title}</h3>
                  <p className="mt-3 text-muted2 leading-relaxed">{s.body}</p>
                </div>
              );
            })}
          </div>

          <div className="mt-20 text-center">
            <Link to="/book" className="btn-primary text-base" data-testid="services-book-cta">
              Book a service
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
